/**
 * SaikalyOnlineShop — subtle on-scroll reveal.
 * Adds .sk-visible to [data-sk-reveal] elements as they enter the viewport.
 */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('sk-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  function bind() {
    document.querySelectorAll('[data-sk-reveal]:not(.sk-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);

  // Re-bind when Shopify theme editor injects/reloads sections.
  document.addEventListener('shopify:section:load', bind);
})();
